import { applicationModuleRegistry } from '@philips-internal/oswald-ui-foundation';
import { ApplicationRoute } from '../../constants/routes';

export function setupChemotherapy(): void {
  applicationModuleRegistry.register({
    entry: 'CHEMO#9140',
    id: 'CHEMO#9140',
    name: 'text.chemotherapy',
    route: ApplicationRoute.CHEMOTHERAPY,
    routes: [
      {
        main: true,
        name: 'function.list-of-patients',
        route: ApplicationRoute.SEARCH_PATIENT,
      }
    ]
  });
}
